import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const CATS = [
    ["pts", "PTS"],
    ["reb", "REB"],
    ["ast", "AST"],
    ["stl", "STL"],
    ["blk", "BLK"],
    ["fls", "FLS"],
];

function SideList({ title, color, rows, testid }) {
    if (!rows.length) return null;
    const totals = rows.reduce((acc, r) => {
        CATS.forEach(([k]) => {
            acc[k] = (acc[k] || 0) + (r[k] || 0);
        });
        return acc;
    }, {});
    return (
        <div data-testid={testid}>
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] mb-2" style={{ color }}>
                {title}
            </p>
            <div className="border border-[#262638] rounded-xl overflow-hidden">
                <div className="grid grid-cols-[minmax(0,1fr)_repeat(6,minmax(1.5rem,2rem))] items-center gap-x-0.5 px-2 py-2 bg-[#12121A] text-[9px] font-semibold uppercase tracking-wider text-slate-500">
                    <span>Player</span>
                    {CATS.map(([k, label]) => (
                        <span key={k} className="text-right">
                            {label}
                        </span>
                    ))}
                </div>
                <div className="divide-y divide-[#1c1c28]">
                    {rows.map((r) => (
                        <div
                            key={r.player_id}
                            data-testid={`${testid}-row-${r.player_id}`}
                            className="grid grid-cols-[minmax(0,1fr)_repeat(6,minmax(1.5rem,2rem))] items-center gap-x-0.5 px-2 py-2"
                        >
                            <span className="min-w-0 truncate text-[11px] sm:text-xs text-slate-200">
                                <span className="font-stat text-[#FF5500] mr-1">#{r.number ?? "—"}</span>
                                {r.name}
                            </span>
                            {CATS.map(([k]) => (
                                <span
                                    key={k}
                                    className={`text-right font-stat text-[11px] sm:text-xs ${
                                        k === "pts" ? "text-[#FFB800] font-bold" : "text-slate-400"
                                    }`}
                                >
                                    {r[k] ?? 0}
                                </span>
                            ))}
                        </div>
                    ))}
                    <div className="grid grid-cols-[minmax(0,1fr)_repeat(6,minmax(1.5rem,2rem))] items-center gap-x-0.5 px-2 py-2 bg-[#0C0C13]">
                        <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">Totals</span>
                        {CATS.map(([k]) => (
                            <span key={k} className="text-right font-stat text-[11px] sm:text-xs font-bold text-white">
                                {totals[k] || 0}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function GameStats({ game }) {
    const [data, setData] = useState(null);
    const isFinal = game.status === "final";

    useEffect(() => {
        if (!isFinal) return undefined;
        let cancelled = false;
        api.get(`/games/${game.id}/stats`)
            .then((r) => !cancelled && setData(r.data))
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, [game.id, isFinal]);

    if (!isFinal || !data || (!data.home.length && !data.away.length)) return null;

    return (
        <div data-testid={`game-stats-${game.id}`} className="mt-5 pt-4 border-t border-[#262638]">
            <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-400 mb-3">Game Stats</p>
            <div className="grid grid-cols-1 gap-5">
                <SideList
                    title={game.home_team?.name || "Home"}
                    color={game.home_team?.primary_color || "#FF5500"}
                    rows={data.home}
                    testid={`game-stats-home-${game.id}`}
                />
                <SideList
                    title={game.away_team?.name || "Away"}
                    color={game.away_team?.primary_color || "#FFB800"}
                    rows={data.away}
                    testid={`game-stats-away-${game.id}`}
                />
            </div>
        </div>
    );
}
